<template>
  <main class="container-1">

    <div class="container-header">
      <Breadcrumb :links="routesBread" />
      <!-- <h2>General</h2> -->
      <TabNav :links="routesNav" />
    </div>

    <div class="container-body">

      <section class="summary-block">
        <h2 class="summary-block__title">Resumen de actividad</h2>
        <div class="summary-cards">
          <div class="summary-card">
            <span class="summary-card__value">{{ filteredActiveUsers.length }}</span>
            <span class="summary-card__label">Usuarios activos</span>
          </div>
          <div class="summary-card">
            <span class="summary-card__value">{{ monitoringSummary ? monitoringSummary.logs_today : '–' }}</span>
            <span class="summary-card__label">Acciones hoy</span>
          </div>
          <div class="summary-card">
            <span class="summary-card__value">{{ monitoringSummary ? monitoringSummary.active_layers : '–' }}</span>
            <span class="summary-card__label">Capas activas</span>
          </div>
          <div class="summary-card">
            <span class="summary-card__value">{{ monitoringSummary ? monitoringSummary.sessions_today : '–' }}</span>
            <span class="summary-card__label">Sesiones de capas hoy</span>
          </div>
          <div class="summary-card">
            <span class="summary-card__value">{{ monitoringSummary ? monitoringSummary.map_visits_today : '–' }}</span>
            <span class="summary-card__label">Visitas a mapas hoy</span>
          </div>
        </div>
      </section>

      <section class="summary-block">
        <h2 class="summary-block__title">Resumen general</h2>
        <div class="summary-cards">
          <div class="summary-card">
            <span class="summary-card__value">{{ mapsCount }}</span>
            <span class="summary-card__label">Mapas</span>
          </div>
          <div class="summary-card">
            <span class="summary-card__value">{{ categoriesCount }}</span>
            <span class="summary-card__label">Categorías de capas</span>
          </div>
          <div class="summary-card">
            <span class="summary-card__value">{{ groupsCount }}</span>
            <span class="summary-card__label">Grupos de usuarios</span>
          </div>
          <div class="summary-card">
            <span class="summary-card__value">{{ geoCount }}</span>
            <span class="summary-card__label">Geoprocesos</span>
          </div>
          <div class="summary-card">
            <span class="summary-card__value">{{ layersCount }}</span>
            <span class="summary-card__label">Capas</span>
          </div>
          <div class="summary-card">
            <span class="summary-card__value">{{ usersCount }}</span>
            <span class="summary-card__label">Usuarios</span>
          </div>
          <div v-if="hasTerrainPermission" class="summary-card">
            <span class="summary-card__value">{{ terrainCampaignsCount }}</span>
            <span class="summary-card__label">Campañas de terreno</span>
          </div>
        </div>
      </section>

      <!-- Usuarios activos: cabecera + gráfico + listado -->
      <section class="monitoring-section">
        <div class="monitoring-section__header">
          <h3>Usuarios activos <span class="monitoring-badge">{{ filteredActiveUsers.length }}</span></h3>
          <small class="monitoring-hint">Se actualiza automáticamente cada 30 segundos · última vez: {{ lastRefresh }}</small>
        </div>

        <!-- Gráfico por grupo (en vivo) -->
        <div class="chart-section chart-section--inner">
          <span class="chart-live-tag chart-live-tag--header">Por grupo</span>
          <apexchart type="bar" height="220" :options="c2Options" :series="c2Series" />
        </div>

        <!-- Listado -->
        <p class="monitoring-subsection-title">Listado de usuarios</p>
        <div class="monitoring-filters">
          <input v-model="filterUsers" class="monitoring-filter-input" type="text" placeholder="Buscar usuario…" />
          <button v-if="filterUsers" class="monitoring-filter-clear" @click="filterUsers = ''">✕</button>
        </div>
        <div v-if="filteredActiveUsers.length > 0" class="active-users-list">
          <div v-for="user in filteredActiveUsers" :key="user.user_id" class="active-user-item">
            <span class="active-user-item__name">{{ user.firstname }} {{ user.lastname }}</span>
            <span class="active-user-item__time">{{ relativeTime(user.last_seen) }}</span>
          </div>
        </div>
        <p v-else class="monitoring-empty">Sin actividad en los últimos 5 minutos.</p>
      </section>

      <hr class="section-divider" />

      <!-- Gráfico: solicitudes totales por fecha (línea) -->

      <section class="chart-section">
        <div class="chart-section__header">
          <h3>Solicitudes realizadas por fecha</h3>
        </div>
        <div class="chart-filters">
          <label class="monitoring-filter-label">Desde</label>
          <input v-model="c4DateFrom" type="date" class="monitoring-filter-date" @change="loadChart4" />
          <label class="monitoring-filter-label">Hasta</label>
          <input v-model="c4DateTo" type="date" class="monitoring-filter-date" @change="loadChart4" />
        </div>
        <apexchart type="line" height="260" :options="c4Options" :series="c4Series" />
        <p class="chart-note">Registros disponibles los últimos 60 días · fechas anteriores devuelven vacío.</p>
      </section>

      <!-- Actividad reciente (logs) -->
      <section class="monitoring-section">
        <div class="monitoring-section__header">
          <h3>Actividad reciente</h3>
        </div>

        <div class="monitoring-filters monitoring-filters--dates">
          <label class="monitoring-filter-label">Desde</label>
          <input v-model="dateFromLogs" type="date" class="monitoring-filter-date" @change="applyFilter" />
          <label class="monitoring-filter-label">Hasta</label>
          <input v-model="dateToLogs" type="date" class="monitoring-filter-date" @change="applyFilter" />
          <button v-if="dateFromLogs || dateToLogs" class="monitoring-filter-clear" @click="clearDateFilter" title="Limpiar fechas">✕</button>
        </div>
        <div class="monitoring-filters">
          <select v-model="filterModule" @change="applyFilter" class="monitoring-select">
            <option value="">Todos los módulos</option>
            <option v-for="module in logModules" :key="module" :value="module">{{ module }}</option>
          </select>
        </div>
        <div class="monitoring-filters">
          <select v-model="filterOpType" @change="applyFilter" class="monitoring-select">
            <option value="">Todos los tipos</option>
            <option value="CREATE">Creación</option>
            <option value="READ">Lectura</option>
            <option value="UPDATE">Actualización</option>
            <option value="DELETE">Eliminación</option>
            <option value="AUTH">Autenticación</option>
          </select>
          <input v-model="filterLogs" class="monitoring-filter-input" type="text" placeholder="Buscar por usuario, acción, módulo o colección…" />
          <button v-if="filterLogs" class="monitoring-filter-clear" @click="filterLogs = ''">✕</button>
          <button v-if="hasActiveLogFilters" type="button" class="filters-clear-btn" @click="clearLogFilters">Limpiar filtros</button>
        </div>

        <table v-if="activityLogs && activityLogs.length > 0" class="monitoring-table">
          <thead>
            <tr>
              <th class="sortable" @click="onSortLogs('created_at')">
                Fecha <font-awesome-icon :icon="getSortIconLogs('created_at')" />
              </th>
              <th class="sortable" @click="onSortLogs('user')">
                Usuario <font-awesome-icon :icon="getSortIconLogs('user')" />
              </th>
              <th class="sortable" @click="onSortLogs('module')">
                Módulo <font-awesome-icon :icon="getSortIconLogs('module')" />
              </th>
              <th class="sortable" @click="onSortLogs('operation_type')">
                Tipo <font-awesome-icon :icon="getSortIconLogs('operation_type')" />
              </th>
              <th class="sortable" @click="onSortLogs('action')">
                Acción <font-awesome-icon :icon="getSortIconLogs('action')" />
              </th>
              <th class="sortable" @click="onSortLogs('collection')">
                Colección <font-awesome-icon :icon="getSortIconLogs('collection')" />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="log in activityLogs" :key="log.id">
              <td>{{ log.created_at ? formatDate(log.created_at) : 'Entrada Vacía' }}</td>
              <td>{{ [log.firstname, log.lastname].filter(Boolean).join(' ') || log.username || log.user_id || 'Entrada Vacía' }}</td>
              <td>
                <span :class="'monitoring-module monitoring-module--' + moduleClass(log.module)">
                  {{ log.module || 'Entrada Vacía' }}
                </span>
              </td>
              <td>
                <span :class="'monitoring-op monitoring-op--' + opClass(log.operation_type)">
                  {{ opLabel(log.operation_type) || 'Entrada Vacía' }}
                </span>
              </td>
              <td>{{ log.action || 'Entrada Vacía' }}</td>
              <td>{{ log.collection || 'Entrada Vacía' }}</td>
            </tr>
          </tbody>
        </table>
        <p v-else class="monitoring-empty">No hay registros de actividad.</p>

        <div v-show="totalPages > 1" class="pagination-wrap">
          <Pagination
            :totalPages="totalPages"
            :currentPage="currentPage"
            :pageSize="pageSize"
            @pagechanged="pageChangedClick"
          />
        </div>
      </section>

    </div>

    <!-- <SideNav class="container-sidenav" :links="routesNav" /> -->

  </main>
</template>

<script>
var moment = require('moment')

import SideNav from '@/components/SideNav.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'
import Pagination from '@/components/Pagination.vue'
import TabNav from '@/components/TabNav.vue'
import { pagination } from '@/components/mixin/pagination.js'
import { restCount } from '@/components/mixin/restCount.js'
import { restMonitoring } from '@/components/mixin/restMonitoring.js'

export default {
  components: { SideNav, Breadcrumb, Pagination, TabNav },
  mixins: [pagination, restCount, restMonitoring],
  data() {
    return {
      filterOpType: '',
      filterModule: '',
      logModules: [],
      filterLogs: '',
      filterUsers: '',
      dateFromLogs: '',
      dateToLogs: '',
      sortKeyLogs: '',
      sortOrderLogs: 'asc',
      lastRefresh: '--',
      pollingInterval: null,
      c4DateFrom: '',
      c4DateTo: '',
      c4Data: [],
      terrainCampaignsCount: 0
    }
  },
  computed: {
    hasTerrainPermission() {
      const terrain = this.$store.getters.getPermissions && this.$store.getters.getPermissions.terrain
      return !!(terrain && (terrain.manage || terrain.respond || terrain.review || terrain.publish))
    },
    c2Grouped() {
      // Cada usuario activo cuenta una vez por cada grupo al que pertenece (unión): un usuario
      // en 2 grupos suma 1 en cada uno, por eso la suma de los segmentos puede superar el total
      // de usuarios activos.
      const counts = {}
      this.activeUsers.forEach(u => {
        const names = (u.group_names && u.group_names.length) ? u.group_names : ['Sin grupo']
        names.forEach(name => {
          counts[name] = (counts[name] || 0) + 1
        })
      })
      return Object.entries(counts).sort((a, b) => b[1] - a[1])
    },
    c2Options() {
      return {
        chart: { type: 'bar', stacked: true, toolbar: { show: false }, fontFamily: 'inherit', animations: { enabled: false }, zoom: { enabled: false } },
        xaxis: { categories: ['Usuarios activos'] },
        yaxis: { title: { text: 'Usuarios activos' }, min: 0, forceNiceScale: true },
        plotOptions: { bar: { columnWidth: '30%' } },
        dataLabels: { enabled: true, style: { fontSize: '13px' } },
        legend: { show: true, position: 'top' },
        tooltip: { theme: 'light' },
        noData: { text: 'Sin usuarios activos en este momento', style: { color: '#aaa', fontSize: '13px' } }
      }
    },
    c2Series() {
      return this.c2Grouped.map(([name, count]) => ({ name, data: [count] }))
    },
    c4Options() {
      return {
        chart: { type: 'line', toolbar: { show: false }, fontFamily: 'inherit', animations: { enabled: false }, zoom: { enabled: false } },
        stroke: { curve: 'straight', width: 2 },
        markers: { size: 3, hover: { size: 5 } },
        xaxis: { categories: this.c4Data.map(d => d.date), tickAmount: 10, labels: { rotate: -30 } },
        yaxis: { title: { text: 'Solicitudes' }, min: 0, forceNiceScale: true },
        colors: ['#3b6e94'], // #2b7a78
        dataLabels: { enabled: false },
        tooltip: { theme: 'light' },
        noData: { text: 'Sin datos para el período seleccionado', style: { color: '#aaa', fontSize: '13px' } }
      }
    },
    c4Series() {
      return [{ name: 'Solicitudes', data: this.c4Data.map(d => d.count) }]
    },
    hasActiveLogFilters() {
      return this.filterOpType !== '' ||
        this.filterModule !== '' ||
        this.filterLogs !== '' ||
        this.dateFromLogs !== '' ||
        this.dateToLogs !== '' ||
        this.sortKeyLogs !== ''
    },
    filteredActiveUsers() {
      const q = this.filterUsers.toLowerCase().trim()
      if (!q) return this.activeUsers
      return this.activeUsers.filter(u =>
        (u.firstname || '').toLowerCase().includes(q) ||
        (u.lastname || '').toLowerCase().includes(q) ||
        (u.username || '').toLowerCase().includes(q)
      )
    },
    routesNav() {
      return [
        { name: 'Secciones' },
        { name: 'General', path: '/monitoreo/general' },
        { name: 'Mapas', path: '/monitoreo/mapas' },
        { name: 'Capas', path: '/monitoreo/capas' },
        { name: 'Terreno', path: '/monitoreo/terreno' },
      ]
    },
    routesBread() {
      return [{ name: 'Monitoreo' }]
    }
  },
  watch: {
    filterLogs(val) {
      clearTimeout(this._logsSearchTimer)
      this._logsSearchTimer = setTimeout(() => {
        this.currentPage = 1
        this.getActivityLogs(1, this.filterOpType, this.dateFromLogs, this.dateToLogs, val, this.sortKeyLogs, this.sortOrderLogs, this.filterModule)
      }, 400)
    }
  },
  methods: {
    getTerrainCampaignsCount() {
      this.$http.get(this.$store.getters.backendurl + 'api/v1/terrain/campaigns', { params: { page: 1, size: 1 } })
        .then(response => {
          this.terrainCampaignsCount = (response.data && response.data.total) || 0
        })
        .catch(error => {
          console.log(error)
        })
    },
    formatDate(date) {
      moment.locale('es')
      return moment(date).format('DD/MM/YYYY HH:mm:ss')
    },
    relativeTime(date) {
      moment.locale('es')
      return moment(date).fromNow()
    },
    opClass(opType) {
      return (opType || '').toLowerCase()
    },
    opLabel(opType) {
      const labels = { CREATE: 'Creación', READ: 'Lectura', UPDATE: 'Actualización', DELETE: 'Eliminación', AUTH: 'Autenticación' }
      return labels[opType] || opType
    },
    // Slug explícito en vez de derivarlo de la etiqueta: los nombres llevan
    // tildes y espacios ("Acceso a plataforma"), y el backend es libre de
    // cambiar el texto sin que se rompa el color.
    moduleClass(module) {
      const classes = {
        'Acceso a plataforma': 'acceso',
        'Visor': 'visor',
        'Mapas': 'mapas',
        'Capas': 'capas',
        'Usuarios': 'usuarios',
        'Perfil de Usuario': 'perfil',
        'Geoprocesos': 'geoprocesos',
        'Documentos': 'documentos',
        'Monitoreo': 'monitoreo'
      }
      return classes[module] || 'otro'
    },
    applyFilter() {
      this.currentPage = 1
      this.getActivityLogs(1, this.filterOpType, this.dateFromLogs, this.dateToLogs, this.filterLogs, this.sortKeyLogs, this.sortOrderLogs, this.filterModule)
    },
    pageChangedClick(page) {
      this.currentPage = page
      this.getActivityLogs(page, this.filterOpType, this.dateFromLogs, this.dateToLogs, this.filterLogs, this.sortKeyLogs, this.sortOrderLogs, this.filterModule)
    },
    onSortLogs(key) {
      if (this.sortKeyLogs === key) {
        if (this.sortOrderLogs === 'asc') {
          this.sortOrderLogs = 'desc'
        } else {
          this.sortKeyLogs = ''
          this.sortOrderLogs = 'asc'
        }
      } else {
        this.sortKeyLogs = key
        this.sortOrderLogs = 'asc'
      }
      this.currentPage = 1
      this.getActivityLogs(1, this.filterOpType, this.dateFromLogs, this.dateToLogs, this.filterLogs, this.sortKeyLogs, this.sortOrderLogs, this.filterModule)
    },
    getSortIconLogs(key) {
      if (this.sortKeyLogs !== key) return 'sort'
      return this.sortOrderLogs === 'asc' ? 'sort-up' : 'sort-down'
    },
    clearDateFilter() {
      this.dateFromLogs = ''
      this.dateToLogs = ''
      this.applyFilter()
    },
    clearLogFilters() {
      this.filterOpType = ''
      this.filterModule = ''
      this.filterLogs = ''
      this.dateFromLogs = ''
      this.dateToLogs = ''
      this.sortKeyLogs = ''
      this.sortOrderLogs = 'asc'
      this.applyFilter()
      // El watcher de filterLogs agenda un fetch debounced redundante; se cancela
      this.$nextTick(() => clearTimeout(this._logsSearchTimer))
    },
    today() { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}` },
    daysAgo(n) { const d = new Date(); d.setDate(d.getDate() - n); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}` },
    loadChart4() {
      this.getChartRequestsByDate(this.c4DateFrom, this.c4DateTo)
        .then(data => { this.c4Data = data })
    },
    refreshActiveUsers() {
      this.getActiveUsers().then(() => {
        moment.locale('es')
        this.lastRefresh = moment().format('HH:mm:ss')
      })
    }
  },
  created() {
    if (!this.$store.getters.getPermissions || !this.$store.getters.getPermissions.monitoring) {
      this.$router.push('/pagina-no-encontrada')
    }
  },
  mounted() {
    this.getMapsCount()
    this.getLayersCount()
    this.getGeoCount()
    this.getUsersCount()
    this.getCategoriesCount()
    this.getGroupsCount()
    if (this.hasTerrainPermission) {
      this.getTerrainCampaignsCount()
    }

    this.c4DateFrom = this.daysAgo(60)
    this.c4DateTo = this.today()
    this.refreshActiveUsers()
    this.getActivityLogs(this.currentPage, this.filterOpType)
    this.getLogModules().then(modules => { this.logModules = modules })
    this.getSummary()
    this.loadChart4()
    this.pollingInterval = setInterval(this.refreshActiveUsers, 30000)
  },
  beforeDestroy() {
    clearInterval(this.pollingInterval)
    clearTimeout(this._logsSearchTimer)
  }
}
</script>

<style lang="scss" scoped>
.summary-block {
  margin-bottom: 2rem;

  &__title {
    margin: 0 0 0.75rem;
    color: var(--color-navy);
    font-size: 1.15rem;
    font-weight: 700;
  }
}

.summary-cards {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.summary-card {
  flex: 1;
  min-width: 110px;
  padding: 0.85rem 1rem;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: #fff;

  &__value {
    display: block;
    font-size: 1.9em;
    font-weight: 700;
    color: var(--color-steel);
    line-height: 1;
  }

  &__label {
    display: block;
    font-size: 0.78em;
    color: #777;
    margin-top: 0.35rem;
  }
}

.monitoring-section {
  margin-bottom: 1rem;

  &__header {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 0.75rem;
    flex-wrap: wrap;

    h3 {
      margin: 0;
    }

    &--spread {
      justify-content: space-between;
      align-items: flex-start;
    }
  }
}

.monitoring-subsection-title {
  font-size: 0.9em;
  font-weight: 600;
  color: #444;
  margin: 1rem 0 0.5rem;
}

.monitoring-filters {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  flex-wrap: wrap;

  &--dates {
    flex-wrap: nowrap;
  }
}

.monitoring-filter-label {
  font-size: 0.82em;
  color: #666;
  white-space: nowrap;
}

.monitoring-filter-date {
  padding: 0.3rem 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.85em;
  outline: none;

  &:focus {
    border-color: var(--color-steel);
  }
}

.monitoring-filter-input {
  flex: 1;
  min-width: 160px;
  padding: 0.4rem 0.65rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.85em;
  outline: none;

  &:focus {
    border-color: var(--color-steel);
  }
}

.monitoring-filter-clear {
  background: transparent;
  border: 1px solid #ddd;
  border-radius: 4px;
  color: #888;
  cursor: pointer;
  font-size: 0.8em;
  padding: 0.25rem 0.5rem;

  &:hover {
    color: #c0392b;
    border-color: #c0392b;
  }
}

.monitoring-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #2b7a78;
  color: #fff;
  border-radius: 999px;
  font-size: 0.85em;
  padding: 0 0.55em;
  min-width: 1.6em;
  height: 1.6em;
  font-weight: 600;
}

.monitoring-hint {
  color: #888;
  font-size: 0.8em;
}

.monitoring-empty {
  color: #888;
  font-style: italic;
}

.active-users-list {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.active-user-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.4rem 0.6rem;
  background: #f5f5f5;
  border-radius: 4px;
  font-size: 0.9em;

  &__time {
    color: #666;
    font-size: 0.85em;
  }
}

.refresh-btn {
  background: transparent;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  padding: 0.28rem 0.65rem;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  color: #555;
  font-size: 0.85em;
  line-height: 1;
  white-space: nowrap;

  svg {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
  }

  &:hover {
    border-color: var(--color-steel);
    color: var(--color-steel);
  }
}

.monitoring-select {
  padding: 0.25rem 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 0.9em;
}

.monitoring-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9em;

  th, td {
    padding: 0.5rem 0.75rem;
    text-align: left;
    border-bottom: 1px solid #e5e5e5;
  }

  th {
    background: var(--color-navy);
    color: #fff;
    font-weight: 600;
  }

  th.sortable {
    cursor: pointer;
    user-select: none;
  }

  th.sortable:hover {
    background: var(--color-steel);
  }

  tr:hover td {
    background: #fafafa;
  }
}

.monitoring-op {
  display: inline-block;
  padding: 0.15em 0.5em;
  border-radius: 4px;
  font-size: 0.8em;
  font-weight: 600;

  &--create { background: #d4edda; color: #155724; }
  &--read   { background: #d1ecf1; color: #0c5460; }
  &--update { background: #fff3cd; color: #856404; }
  &--delete { background: #f8d7da; color: #721c24; }
  &--auth   { background: #ede0f7; color: #6b21a8; }
}

// Badge de módulo: un color por parte del sistema. Comparte forma con
// .monitoring-op (columna vecina) pero usa hues distintos para que ambas
// insignias de una misma fila no se confundan entre sí.
.monitoring-module {
  display: inline-block;
  padding: 0.15em 0.5em;
  border-radius: 4px;
  font-size: 0.8em;
  font-weight: 600;
  white-space: nowrap;

  &--acceso      { background: #e2e8f0; color: #334155; }
  &--visor       { background: #dbeafe; color: #1e40af; }
  &--mapas       { background: #ccfbf1; color: #115e59; }
  &--capas       { background: #dcfce7; color: #166534; }
  &--usuarios    { background: #ede9fe; color: #5b21b6; }
  &--perfil      { background: #cffafe; color: #155e75; }
  &--geoprocesos { background: #ffedd5; color: #9a3412; }
  &--documentos  { background: #fef9c3; color: #854d0e; }
  &--monitoreo   { background: #fce7f3; color: #9d174d; }
  &--otro        { background: #f1f5f9; color: #64748b; }
}

.pagination-wrap {
  margin-top: 1rem;
}

.chart-section {
  margin-bottom: 1rem;
  background: #f9fafb;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  padding: 1rem 1.25rem 0.75rem;

  &__header h3 {
    margin: 0 0 0.75rem;
    font-size: 1em;
    color: #333;
  }

  &--inner {
    margin-bottom: 0;
    background: #f9fafb;
    padding: 0.75rem 1rem 0.5rem;
  }
}

.chart-filters {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: nowrap;
  margin-bottom: 0.75rem;
}

.section-divider {
  border: none;
  border-top: 1px solid var(--color-line);
  margin: 0 0 1rem;
}

.chart-note {
  margin: 0.5rem 0 0;
  font-size: 0.78em;
  color: #f59e0b;
  font-style: italic;
}

.chart-live-tag {
  font-size: 0.72em;
  font-weight: normal;
  background: #e0f2f1;
  color: #2b7a78;
  padding: 0.15em 0.5em;
  border-radius: 4px;
  vertical-align: middle;

  &--header {
    display: inline-block;
    margin-bottom: 0.5rem;
  }
}
</style>
